import { createDomainApi, createReadOnlyApi } from '@skylabs-digital/react-proto-kit';
import {
  budgetInputSchema,
  budgetUsageSchema,
  frequencyBudgetSchema,
} from '../schemas/budget.schema';

export type { BudgetInput, BudgetUsage, FrequencyBudget } from '../schemas/budget.schema';

export const budgetsApi = createDomainApi(
  'preferences/budgets',
  frequencyBudgetSchema,
  budgetInputSchema,
);

export const budgetUsageApi = createReadOnlyApi(
  'preferences/budgets/usage/:userId',
  budgetUsageSchema,
);
